export default __webpack_public_path__ + "static/media/app_link_button_android.44eaa664.png";